import React, { Component } from 'react';
var HtmlToReactParser = require('html-to-react').Parser;


export default class extends Component {
    render() {
        return (
            <div className="main-area active show">
                <div className={"content-area " + (this.props.tabMenuClass) + (this.props.isShow ? "" : " hidden")}>
                    {new HtmlToReactParser().parse(this.props.content)}    
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/content/ContentText.js